import { render, staticRenderFns } from "./hospitalStatistics.vue?vue&type=template&id=2d4e4d8e&scoped=true&"
import script from "./hospitalStatistics.vue?vue&type=script&lang=js&"
export * from "./hospitalStatistics.vue?vue&type=script&lang=js&"
import style0 from "./hospitalStatistics.vue?vue&type=style&index=0&id=2d4e4d8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4e4d8e",
  null
  
)

export default component.exports